module.exports = __webpack_public_path__ + "static/media/sign.5f99dbb9.png";